'use es6';

import http from 'conversations-http/clients/http';
export const getFileStatus = ({
  fileIds
}) => http.get('filemanager/api/v3/files/download-states', {
  query: {
    fileId: fileIds
  }
});